import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {Tab} from '@common-module/app-enums/tab';

const PUBLIC_KEY_PARAM = 'publickey';

/**
 * Публичная ссылка вида /public?publicKey=... открывается анонимно: ключ заменяет
 * авторизацию, бэкенд принимает его в заголовке publicKey. Ключ проверяем вместе
 * с путём, чтобы приписанный к приватному маршруту publicKey не снимал защиту.
 */
export function isPublicLink(url: string): boolean {
  const [path, query = ''] = url.split('#')[0].split('?');
  const isPublicPath = path.replace(/^\/+/, '').split('/')[0] === Tab.PUBLIC;
  const hasPublicKey = new URLSearchParams(query.toLowerCase()).has(PUBLIC_KEY_PARAM);
  return isPublicPath && hasPublicKey;
}

/**
 * Тот же признак, но по адресу страницы: нужен на этапе APP_INITIALIZER,
 * когда Router ещё не поднят, а решение про вход в Keycloak уже принимается.
 */
export function isPublicLocation(): boolean {
  return isPublicLink(`${window.location.pathname}${window.location.search}`);
}

export const authGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  if (isPublicLink(state.url)) {
    return true;
  }
  return inject(KeycloakService).isLoggedIn();
};
